import { getAuth } from "firebase/auth"

export const decodeMessage = (message: string): string => {
  try {
    let processedMessage = message.replace(/^["'](.*)["']$/, "$1")

    // Check if the message is already decoded by attempting to encode it
    const encoded = JSON.stringify(processedMessage)
    const decoded = JSON.parse(encoded)

    if (processedMessage.includes("\\u")) {
      return decoded.replace(/\\u[\dA-F]{4}/gi, (match) =>
        String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16)),
      )
    }

    return processedMessage
  } catch (error) {
    return message.replace(/^["'](.*)["']$/, "$1")
  }
}

export const isAnonymous = () => {
  const auth = getAuth()
  return (
    auth?.currentUser?.isAnonymous ||
    auth?.currentUser?.providerData.length == 0
  )
}

export const isInIframe = () => {
  try {
    return window !== window.parent
  } catch (e) {
    return true
  }
}

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const postMessageToParent = (message: Record<string, any>) => {
  if (!isInIframe()) {
    return
  }

  try {
    window.parent.postMessage(message, "*")
  } catch (error) {
    console.error("Error posting message to parent:", error)
  }
}
